import React, {Component} from 'react'
import PrintPreview from './PrintPreview'
import PdfStore from 'stores/PdfStore'
import FontAwesome from 'react-fontawesome'

const DEFAULT_ROW = 2
class PrintShippingLabel extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:{},dataList:[],report_title:'กำลังดึงข้อมูล..'}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData() {
    let {data,dataList} = this.state
    PdfStore.loadShippingLabel(this.props.docType,this.props.idList,(result) => {
      data = result.data
      dataList = this.getPagination(result.data.list)
      this.setState({data:data,dataList:dataList,report_title:'ไม่พบข้อมูล'})
    })
  }

  renderHeader() {
    let {data} = this.state
    return(
      <table className='table table-header-print-kkc-billing-note' style={{marginBottom:'0'}}>
        <tbody>
          <tr>
            <td>{data.company_name} {data.company_branch}</td>
          </tr>
          <tr>
            <td>{data.company_addr}</td>
          </tr>
          <tr>
            <td>โทร. {data.company_tel}</td>
          </tr>
        </tbody>
      </table>
    )
  }

  renderTable(item) {
    return(
      <div className='text-center' style={{marginTop:'27%'}}>
        <table className='table table-header-print-kkc-billing-note'>
          <tbody>
            <tr>
                <td style={{width:'40%'}} className='text-left'></td>
                <td style={{width:'40%'}} className='text-left'>กรุณานำส่ง</td>
                <td style={{width:'40%'}} className='text-left'></td>
            </tr>
            <tr>
                <td style={{width:'40%'}} className='text-left'></td>
                <td style={{width:'40%'}} className='text-left'>{item.customer_name!==''?item.customer_name:'-'}</td>
                <td style={{width:'40%'}} className='text-left'></td>
            </tr>
            <tr>
                <td style={{width:'40%'}} className='text-left'></td>
                <td style={{width:'40%'}} className='text-left'>{item.customer_address!==''?item.customer_address:'-'}</td>
                <td style={{width:'40%'}} className='text-left'></td>
            </tr>
            {item.customer_tel!==undefined&&item.customer_tel!==null?
            <tr>
                <td style={{width:'40%'}} className='text-left'></td>
                <td style={{width:'40%'}} className='text-left'>{item.customer_tel!==''?'โทร. '+item.customer_tel:''}</td>
                <td style={{width:'40%'}} className='text-left'></td>
            </tr>
            :''}
          </tbody>
        </table>
      </div>
    )      
  }

  renderAll(items) {
    return(
      items.map((item,index) => {
        return(
          <div key={index}>
            <div className='font-22 box-label'>
              {this.renderHeader()}
              {this.renderTable(item)}
            </div>
            <div style={{position:'relative',width:'100%',display:((items.length>1&&items.length-1!==index)||(items.length===1))?'':'none'}}>
              <div style={{width:'5%',float:'left'}}>
                <FontAwesome name='scissors' className='scissors' />
              </div>
              <div style={{width:'95%',float:'right'}}>
                <hr className='hr-billing-note' />
              </div> 
            </div>
          </div>
        )
      })
    )  
  }

  renderComponentPage(item,index,total) {
    return(
      <div className='font-print' key={index}>
        {this.renderAll(item)}  
      </div>  
    )
  }

  getPagination(data) {
    let allData = []
    let newData = []
    let checkRow = -1
    data.forEach((item,index)=>{
        if (checkRow<DEFAULT_ROW)
            checkRow++

        newData.push(item)
    
        if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
            allData.push(newData)
            checkRow = -1
            newData = []
        }    
    })
    return allData
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    if (dataList.length===0) {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
          showPageNumber={false}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
          showPageNumber={false}
        >
          {
            dataList.map((item,index) => {
              return(
                this.renderComponentPage(item,index,dataList.length)
              )
            })
          }
        </PrintPreview>
      )
    }  
  }

}  

PrintShippingLabel.defaultProps = {
  title: 'ใบจ่าหน้าซอง',  
  mode: '1',
  docType: 'invoice'
}
export default PrintShippingLabel;


// WEBPACK FOOTER //
// ./src/view/print/PrintShippingLabel.js